import {ChangeDetectionStrategy, Component} from '@angular/core';
import {ConsumptionReportSearchCriteriaComponent} from './consumption-report-search-criteria/consumption-report-search-criteria.component';
import {Criteria} from './types/criteria.model';
import {ConsumptionResultTableComponent} from './consumption-result-table/consumption-result-table.component';

@Component({
    selector: 'app-consumptions-reports',
    standalone: true,
    imports: [ConsumptionReportSearchCriteriaComponent, ConsumptionResultTableComponent],
    templateUrl: './consumptions-reports.component.html',
    styleUrl: './consumptions-reports.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConsumptionsReportsComponent {
    criteria: Criteria | null = null;
    updateConsumptionCriteria(criteria: Criteria): void {
        this.criteria = criteria;
    }
    backToCriteria(): void {
        this.criteria = null;
    }
}
